import {OETarget} from '../../../react-oe/oe-target';
import {OEVersion} from '../../../react-oe/oe-version';
import {OELicensingEdition} from '../../../react-oe/oe-types';
import {OEVersionFeatureAccess, OEVersionTargetsAlphaBetaProds, OEVersionStartSelectionDataAlphaBetaProd} from '../oe-proto-model';
import {OEXRayTargetType as OEXRayTargetType_, OEXRayTargetSelector, OEXRayStartSelectionContentFactory} from './oe-xray-consts';

export const OEXRayTargetType = OEXRayTargetType_;

//
export const OEXRayTargetsFactory = {

    createForVersion(version)   {

        let targeteSelector = new OEXRayTargetSelector(version);

        return new OEVersionTargetsAlphaBetaProds(
            {
                [OEXRayTargetType.xRayArm]: [
                    targeteSelector.get(OETarget.xRayUpperExtremity)
                ],
                [OEXRayTargetType.xRayLeg]: [
                    targeteSelector.get(OETarget.xRayLowerExtremity)
                ],
                [OEXRayTargetType.xRayTrunk]: [
                    targeteSelector.get(OETarget.xRayTrunk)
                ],
                [OEXRayTargetType.anatomy]: [
                    OETarget.humanArm,
                    OETarget.humanShoulderGirdle,
                    OETarget.humanHip2,
                    OETarget.humanThighKnee,
                    OETarget.humanAnkleFoot,
                    OETarget.humanTrunk,
                    OETarget.humanNeckBack
                ]
            },
            {
                [OEXRayTargetType.anatomy]: OETarget.humanArm,
            },
            {
                [OEXRayTargetType.anatomy]: OETarget.humanArm,
            }
        );
    }
};

//
export const OEXRayTargetsSelector = {
    get(version)    {
        version = version === OEVersion.xRayMin ? version : OEVersion.xRay;
        if(!this[version])  this[version] = OEXRayTargetsFactory.createForVersion(version);
        return this[version];
    }
};

//
export class OEXRayFeatureAccess extends OEVersionFeatureAccess {

    constructor(versionTargets) {
        super(versionTargets);
    }

    initialFeatureAccess()  {
        let isLicensing = this.isLicensing();
        return Object.assign(this.createFeatureAccessObj(), {
            xRayArmTargetSelection: !isLicensing,
            xRayLegTargetSelection: !isLicensing,
            xRayTrunkTargetSelection: !isLicensing,
            anatomyTargetSelection: !isLicensing
        });
    }

    featureAccessForLicensingAccess(licensingAccess)    {
        if(!licensingAccess.isLicensing)    return this.createFeatureAccessObj();

        let featureAccess = this.initialFeatureAccess();

        if(licensingAccess.isValid)    {
            if(OELicensingEdition.allAbove(OELicensingEdition.basic).includes(licensingAccess.edition))  {
                featureAccess.xRayArmTargetSelection = true;
                featureAccess.xRayLegTargetSelection = true;
                featureAccess.xRayTrunkTargetSelection = true;
                featureAccess.anatomyTargetSelection = true;
            }
        }

        return featureAccess;
    }
};

//
export const OEXRayFeatureAccessSelector = {
    get(version)    {
        version = version === OEVersion.xRayMin ? version : OEVersion.xRay;
        if(!this[version])  this[version] = new OEXRayFeatureAccess(OEXRayTargetsSelector.get(version));
        return this[version];
    }
};

//
export const OEXRayStartSelectionDataSelector = {
    get(version)    {
        version = version === OEVersion.xRayMin ? version : OEVersion.xRay;
        if(!this[version])  {
            this[version] = new OEVersionStartSelectionDataAlphaBetaProd(
                OEXRayTargetsSelector.get(version),
                OEXRayStartSelectionContentFactory.createForVersion(version)
            );
        }
        return this[version];
    }
};